import { registry } from '@cian/mf-registry/browser';

export async function ensureHeaderMicrofrontend() {
  const api = await registry().microfrontendStrict('header-frontend').api()?.ensure();

  return api;
}
